module.exports = __webpack_public_path__ + "static/media/mrWii.2cb8c6b9.webp";